import { Switch as SwitchAntd } from 'antd';
import styled from 'styled-components';

export const SwitchLinear = styled(SwitchAntd)`
  &[aria-checked='true'] {
    background-color: #17b635;
  }

  &[aria-checked='false'] {
    background-color: #d43131;
  }
`;
